<template>
    <div class="margin_horizontal">
      <div class="text-center">
        <span v-html="redirectInfoText"></span>
      </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {navigationPaths} from "@/common/navigation/navigationPaths";

export default {
	data() {
		return {
			remainingSeconds: 10,
			redirectTimer: null,
			countdownInterval: null,
		};
	},
	created() {
		// In case store values required for redirect are missing, e.g. due to page reloading we force going back to login
		if (!this.redirect.url) {
			this.$router.replace(navigationPaths.login.base);
			return;
		}

		this.redirectTimer = setTimeout(() => {
			window.location.replace(this.redirect.url)
		}, this.remainingSeconds * 1000);

		this.countdownInterval = this.countdownInterval = setInterval(() => {
			this.remainingSeconds--;
		}, 1000)
	},
	beforeDestroy() {
		this.clearRedirect();
		clearTimeout(this.redirectTimer);
		clearInterval(this.countdownInterval);
	},
	computed: {
		...mapGetters(["redirect"]),
		redirectInfoText() {
			return this.$t("redirect.msg", {
				remaining: this.remainingSeconds,
				name: this.redirect.name,
				url: this.redirect.url
			});
		}
	},
	methods: {
		...mapActions(["clearRedirect"]),
	}
};
</script>
